import React, { useState } from 'react'
import { Form, Input, Checkbox, Message } from 'rsuite'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'

export default function CheckboxRowForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
}) {
  const [schema, setSchema] = useState(_schema)

  const [isDisabledInputOther, setIsDisabledInputOther] = useState(!schema?.inputOther?.isSelected)
  // const disabled = props.disabled
  // const OTHER = 'OTHER'

  const onChangeCheckbox = (value, checked) => {
    if (checked) {
      clearErrors('checkbox')
    }

    let optionSelected = [...schema.optionSelected]
    const index = schema.optionSelected.indexOf(value)
    if (checked) {
      if (index === -1) {
        optionSelected = [...schema.optionSelected, value]
      }
    } else {
      if (index > -1) {
        optionSelected.splice(index, 1)
      }
    }

    setSchema((state) => ({
      ...state,
      optionSelected,
    }))
  }

  const onSelectAll = (_, checked) => {
    if (checked) {
      clearErrors('checkbox')
    }

    let optionSelected = []
    if (checked) {
      optionSelected = schema.options.map((item) => {
        setValue(item.name, true)
        return item.value
      })
    } else {
      schema.options.forEach((item) => {
        setValue(item.name, false)
      })
      setIsDisabledInputOther(true)
    }

    setSchema((state) => ({
      ...state,
      optionSelected,
    }))
  }

  const onSelectOther = (_, checked) => {
    clearErrors('checkbox')
    setSchema((state) => ({
      ...state,
      inputOther: { ...state.inputOther, isSelected: checked },
    }))
    setIsDisabledInputOther(!checked)
  }

  const indeterminateSelectALL =
    schema.optionSelected &&
    schema.optionSelected.length > 0 &&
    schema.optionSelected.length < schema.options.length
  const checkedSelectALL =
    schema.optionSelected && schema.optionSelected.length === schema.options.length

  return (
    <>
      <Form>
        <div>
          {schema.description && <CustomIconMessageInfo content={schema.description} />}
          {errors.checkbox && (
            <Message showIcon type="error" description={errors.checkbox.message} />
          )}
          {schema.haveSelectAllCheckbox && (
            <>
              <Checkbox
                name="selectAll"
                indeterminate={indeterminateSelectALL}
                checked={checkedSelectALL}
                onChange={onSelectAll}
              >
                เลือกทั้งหมด
              </Checkbox>
              <hr />
            </>
          )}
          {schema.options.map((item, index) => (
            <Controller
              key={item.name}
              name={item.name}
              control={control}
              defaultValue={schema.optionSelected && schema.optionSelected.includes(item.value)}
              render={(props) => {
                return (
                  <Checkbox
                    value={item.value}
                    checked={props.value}
                    onChange={(value, checked, e) => {
                      props.onChange(checked)
                      onChangeCheckbox(value, checked)
                    }}
                  >
                    {item.label}
                  </Checkbox>
                )
              }} // props contains: onChange, onBlur and value
            />
          ))}
          {schema.inputOther?.enable && (
            <>
              <Controller
                name={'inputOtherCheckbox'}
                control={control}
                defaultValue={schema.inputOther.isSelected}
                render={(props) => {
                  return (
                    <Checkbox
                      value={'OTHER'}
                      checked={!isDisabledInputOther}
                      onChange={(value, checked, e) => {
                        props.onChange(checked)
                        onSelectOther(value, checked)
                      }}
                    >
                      {schema.inputOther.label}
                    </Checkbox>
                  )
                }}
              />
              <Input
                name="inputOther"
                style={{ width: 'calc(100% - 35px)', marginLeft: 35 }}
                placeholder="โปรดระบุ"
                defaultValue={schema.inputOther.value}
                disabled={isDisabledInputOther}
                inputRef={register({ required: schema.inputOther?.isSelected })}
              />
              <div style={{ marginTop: 10, width: 'calc(100% - 35px)', marginLeft: 35 }}>
                {errors.inputOther && <Message showIcon type="error" description={'โปรดระบุ'} />}
              </div>
            </>
          )}
        </div>
      </Form>
    </>
  )
}
